export const PAGE_NAME = {
    LISTINGS_PAGE: 'listings_page',
    CUSTOM_LISTINGS_PAGE: 'custom_listings_page',
};
